<template>
  <img
    src="@/assets/icons/yokohama.png"
    class="yokohama-log flex fixed bottom-0"
    style="width:218px; height:57px; margin-bottom:120px; margin-left:100px; z-index:-100;"
  />
  <div class="flex fixed bottom-0 left-0" style="z-index:-100;">
    <BuildingLeft />
    <BuildingRight />
  </div>
</template>

<script>
import BuildingLeft from '@/assets/icons/building-left.svg?inline'
import BuildingRight from '@/assets/icons/building-right.svg?inline'
export default {
  name: 'TopActive_YOKOHAMA',

  components: {
    BuildingLeft,
    BuildingRight,
  },
}
</script>
<style lang="scss"></style>
